import { action, observable } from "mobx";
import api from "../api";
import { TLessonType } from "../typings/Lesson";
import Service from "./base.service";
import * as Sentry from "@sentry/browser";


export interface AccessControlRules {
  tags: Array<'list' | 'update'>,
  ads: Array<"view" | "list" | "update" | "create" | "delete">,
  answertemplate: Array<"view" | "list" | "update" | "create" | "delete">,
  branding: Array<"view" | "list" | "update" | "create" | "delete">,
  certificates: Array<"view" | "list" | "update" | "create" | "delete">,
  checked: Array<"view" | "list" | "update" | "create" | "delete">,
  contact: Array<"view" | "list" | "update" | "create" | "delete">,
  courses: Array<"view" | "list" | "update" | "create" | "delete" | "view-module">,
  curators: Array<"view" | "list" | "update" | "create" | "delete">,
  diary: Array<"view" | "list" | "update" | "create" | "delete">,
  'event': Array<"view" | "list" | "update" | "create" | "delete">,
  documents: Array<"view" | "list" | "update" | "create" | "delete" | "insert">,
  faq: Array<"view" | "list" | "update" | "create" | "delete">,
  files: Array<"view" | "list" | "update" | "create" | "delete">,
  game: Array<"view" | "list" | "update" | "create" | "delete">,
  group: Array<"view" | "list" | "update" | "create" | "delete">,
  homework: Array<"view" | "list" | "update" | "create" | "delete">,
  /**
   * @integration автодобавление
   */
  integration: Array<"view" | "list" | "update" | "create" | "delete">,
  'lesson-modules': Array<"view" | "list" | "update" | "create" | "delete" | "settings">,
  lessons: Array<"view" | "list" | "update" | "create" | "delete" | TLessonType>,
  mail: Array<"view" | "list" | "update" | "create" | "delete">,
  messages: Array<"view" | "list" | "update" | "create" | "delete">,
  news: Array<"view" | "list" | "update" | "create" | "delete">,
  report: Array<"view" | "list" | "update" | "create" | "delete">,
  room: Array<"view" | "list" | "update" | "create" | "delete">,
  scope: Array<"view" | "list" | "update" | "create" | "delete">,
  sender: Array<"view" | "list" | "update" | "create" | "delete">,
  statistic: Array<"view" | "list" | "update" | "create" | "delete">,
  students: Array<"view" | "list" | "update" | "create" | "delete" | "contacts">,
  'telegram-channels': Array<"view" | "list" | "update" | "create" | "delete">,
}

export type TACLEntities = keyof AccessControlRules;

export default class AccessControlService extends Service {
  static API_EP = '/api/profile/acl'
  @observable
  rules: AccessControlRules;
  @observable
  loading = true;

  course_id: string | number;

  @action
  async byCourse(course_id: string | number) {
    if (this.course_id === course_id) return;
    try {
      this.loading = true;
      const rules: AccessControlRules = await api.user.fetchAccessRulesByCourse(course_id)
      this.rules = rules;
      this.course_id = course_id;
      this.loading = false;
    } catch (error) {
      Sentry.captureException(JSON.stringify(error));
      Sentry.captureMessage(`ACL: ${JSON.stringify(error)})}`)
      console.log(error)
      this.loading = false;
      throw new Error('Невозможно установить права пользователя');
    }
  }

  @action
  async byCourseAndEntity(course_id: string | number, entity: TACLEntities) {

    //const rules = await api.user.fetchAccessRulesByCourse(course_id)
    const rules: Partial<AccessControlRules> = await Promise.resolve({
      tags: ['list']
    });
    this.rules = {
      ...this.rules,
      ...rules
    };
  }


  check<T extends TACLEntities>(entity: T, actions?: AccessControlRules[T]) {
    let result = false;
    if (this.rules && entity in this.rules) {
      const entityActions = this.rules[entity];
      //@ts-ignore
      result = actions.every((action) => entityActions.includes(action));
    }
    return result;
  }

  checkOne<T extends TACLEntities>(entity: T, actions?: AccessControlRules[T]): boolean {
    let result = false;
    if (this.rules && entity in this.rules) {
      const entityActions = this.rules[entity];
      //@ts-ignore
      result = actions.some((action) => entityActions.includes(action));
    }
    return result
  }
}